export const getHash = (source) => {
  let hash = 0
  let i
  let chr

  for (i = 0; i < source.length; i++) {
    chr = source.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }
  return Math.abs(hash)
}
